import { Interval, PlanV2 } from "@zapier/checkout/esm/types";

type Enticements = {
  year: string;
  month: string;
};

export const calculateDiscount = (
  yearlyAmount: number | undefined,
  monthlyAmount: number | undefined
): number => {
  if (!yearlyAmount || !monthlyAmount) {
    return 0;
  }

  const total = monthlyAmount * 12;
  const discount = total - yearlyAmount;

  return Math.floor((discount / total) * 100);
};

export const getOneEnticement = (
  plans: PlanV2[],
  interval: Interval
): string => {
  if (interval !== "year") {
    return "";
  }

  const yearlyInfo = plans.find(p => p.interval === "year");
  const monthlyInfo = plans.find(p => p.interval === "month");

  if (!yearlyInfo || !monthlyInfo) {
    return "";
  }

  if (monthlyInfo.amount * 11 === yearlyInfo.amount) {
    return "free month";
  }

  const discount = calculateDiscount(yearlyInfo.amount, monthlyInfo.amount);
  return `save ${discount}%`;
};

export const getEnticements = (plans: PlanV2[]): Enticements => {
  return plans.reduce(
    (enticements, plan) => ({
      ...enticements,
      [plan.interval]: getOneEnticement(plans, plan.interval),
    }),
    { year: "", month: "" }
  );
};
